import type { TypographyVariantProps } from "./types";

type WhiteSpace = TypographyVariantProps["whiteSpace"];

// Web: CSS handles every `whiteSpace` value, so both pass through unchanged.
// `white-space.native.ts` has the same signature.
export const resolveWhiteSpace = (
  whiteSpace: WhiteSpace,
  numberOfLines: number | undefined,
): { whiteSpace: WhiteSpace; numberOfLines: number | undefined } => ({
  whiteSpace,
  numberOfLines,
});
